import { Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent {
  hideRequiredControl = new UntypedFormControl(false);
  constructor(private appService:AppService,private commonService:CommonService){}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.commonService.setTitle("Chat")
  }
}
